//import all the used libraries
import React, { useState, useContext, useRef, useEffect } from "react"
import {useNavigate, useLocation  } from 'react-router-dom'

import ReactGA from 'react-ga4';

//Import UI libraries
import { 
  Tooltip,
  Container, 
  Grid,
  Box,
  ListItem,
  ListItemText,
  Typography, 
  List, 
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Paper
} from '@material-ui/core'


import { createStyles, makeStyles } from '@material-ui/core/styles';

//Import the contexts we want to use . 
import { LoggedContext } from '../../Context'

import { Warning } from '@material-ui/icons';

import {Logo} from'../Images'

import {DemoMessage} from'../MainPage/MainPage'

import { useDemoStore } from '../../Stores/demoStore'

export const DemoDialog = ({ demoDailog, closeDialog }) => {
  return (
    <Dialog 
      open={demoDailog}
      onClose={closeDialog}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: { maxWidth: 700 }
      }}
    >
      <DialogContent style={{ padding: '16px 24px' }}>
        <Box style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 16,
          marginBottom: 24 
        }}>
          <Warning style={{ 
            color: '#ff9800',
            fontSize: 32 
          }} />
          <Typography variant="h4">
            Είστε σε περιβάλλον δοκιμών
          </Typography>
        </Box>

        <Paper style={{ 
          padding: 24,
          marginBottom: 24,
          backgroundColor: '#f5f5f5',
          elevation: 0
        }}>
          
          <DialogContentText style={{ marginBottom: 16 }}>
            Καλώς ήρθατε στο demo tour της εφαρμογής μας!
          </DialogContentText>
          
          <DialogContentText style={{ marginBottom: 16 }}>
            Αυτή είναι μια δοκιμαστική έκδοση που σας επιτρέπει να εξερευνήσετε 
            τις δυνατότητες της εφαρμογής μας.
          </DialogContentText>
          
          <DialogContentText style={{ marginBottom: 16 }}>
            Ορισμένες λειτουργίες ενδέχεται να είναι περιορισμένες ή να μην 
            είναι διαθέσιμες σε αυτό το περιβάλλον.
          </DialogContentText>
        </Paper>

        <Paper style={{ 
          padding: 16,
          backgroundColor: '#bbdefb',
          marginTop: 16
        }}>
          <DialogContentText>
            Για περισσότερες πληροφορίες σχετικά με την εφαρμογή και τις πλήρεις 
            λειτουργίες της, επισκεφτείτε την ιστοσελίδα μας:{' '}
            <a 
              href="https://app.reger.health" 
              style={{
                color: '#1976d2',
                textDecoration: 'underline',
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              app.reger.health
            </a>
          </DialogContentText>
        </Paper>
      </DialogContent>

      <DialogActions style={{ 
        padding: '16px 24px'
      }}>
        <Button 
          onClick={closeDialog}
          color="secondary"
          variant="contained"
          size="large"
        >
          ΕΠΙΣΤΡΟΦΗ
        </Button>
      </DialogActions>
    </Dialog>
  );
};




export const LogIn = () => {

  

  //Styles
  const useStyles = makeStyles(() =>
    createStyles({
      paper: {
        minHeight:"80vh",
        width:"80vw",
        marginTop: "9vh",
        marginBottom: "9vh",
        margin:"auto",
        maxWidth:"1200px"
      },
      loginHeader: {
        marginTop:"10%",
        marginBottom:"10%",
        letterSpacing: "4px"
      },
      loginSubheader: {
        marginBottom:"10%",
        fontSize: '0.8rem'
      },
      loginButton: {
        marginTop:"10%",
        marginBottom:"10%",
      },
      copywright:{
        marginBottom:"10%",
        marginTop:"1rem"
      },
      terms:{
        color:"#9e9e9e"
      }
    })
  )
  const classes = useStyles()
 
  //Navigate the pages
  const navigate  = useNavigate()
  

  //Copyright informations + link to business site
  const Copyright = () => {
    return (
      <Typography className={classes.copywright} variant="body2" color="textSecondary" align="left">
        {'Copyright © '}
        <a href="https://www.reger.health/" target="_blank">Reger Health</a>
        {' '}
        {new Date().getFullYear()}
      </Typography>
    );
  }
  //A simple form component used by the user to log in
  const LogInForm = () => {

    //Is the user authenticated
    const [logged, setLogged] = useContext(LoggedContext)
    const setDemoMessage = useDemoStore(state => state.setDemoMessage)

 

    //Open close the Demo dialog
    const [demoDailog, setDemoDailog] = useState(false)


   
    async function login() {
      setLogged (true)
      navigate("/MainPage")
    }

    
 
    const demo = () =>{
      setDemoMessage({
        status:true,
        severity:"info",
        description:"το κουμπί αυτό προβάλλει τις αντίστοιχες πληροφορίες."
      })
    }
 



  
   


    return (
      <>

       
        <DemoDialog 
          demoDailog={demoDailog} 
          closeDialog={() => setDemoDailog(false)} 
        />


        <DemoMessage/>
      

        <Container maxWidth="xs">
          <Grid
          container
          direction="row"
          alignItems="center"
          >
            

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
              <Typography className={classes.loginHeader} color='textSecondary' variant="h4" align='left'>
                i-prescription (Demo)
              </Typography>
            </Grid>


            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
     

     

            <Typography variant="subtitle2"  color="textSecondary">
              Αυτή είναι μια demo έκδοση της εφαρμογής iPrescription, ενός ολοκληρωμένου συστήματος ηλεκτρονικής συνταγογράφησης που αναπτύχθηκε από την εταιρεία Reger Health. Σας προσφέρουμε την ευκαιρία να εξερευνήσετε και να δοκιμάσετε τις δυνατότητες της εφαρμογής σε ένα ασφαλές περιβάλλον δοκιμών.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" color="textSecondary" paragraph >
              <strong>Εξαιρετικά σημαντικό:</strong> Όλα τα δεδομένα είναι εικονικά και οποιαδήποτε ενέργεια δεν έχει καμία επίδραση στο κρατικό σύστημα.
              Δεν δημιουργούνται πραγματικές συνταγές ή παραπεμπτικά. Δεν καταχωρούνται πραγματικά δεδομένα ασθενών. Δεν υπάρχει καμία σύνδεση με το εθνικό σύστημα ηλεκτρονικής συνταγογράφησης.
            </Typography>

       
            <Typography variant="subtitle2" color="textSecondary" >
              Προορίζεται αποκλειστικά για επαγγελματίες υγείας.
            </Typography>
            <br></br>
            <br></br>
            </Grid>

     

            <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} >
              
              <Grid container direction="row" justifyContent="space-between" > 
         
                <Grid item xs={12}>
                  <Button
                    onClick={login}
                    variant="outlined"
                  >
                    ΕΙΣΟΔΟΣ
                  </Button>
                </Grid>
                

                <Grid style={{marginTop: '10%',}} item>
                  <Typography onClick={demo} style={{ fontSize: '0.8rem', cursor: 'pointer', align:"left" }} color='textSecondary' variant='subtitle2'> Πολιτική Προστασίας Προσωπικών Δεδομένων</Typography>
                  <Typography onClick={demo} style={{ fontSize: '0.8rem', cursor: 'pointer', align:"left" }} color='textSecondary' variant='subtitle2'> Όροι χρήσης εφαρμογής </Typography>
                </Grid>

              </Grid>

             

            </Grid> 

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
              <Copyright/>
            </Grid> 
            
            

          </Grid>
        </Container>
      
      </>      
    )
  }





  return ( 
    <Paper className={classes.paper} elevation={16} >
    <Grid
    container
    direction="row"
    alignItems="center"
    >

      <Grid  item xs={12} sm={12} md={6} lg={6} xl={6} >                
        <Logo/>  
      </Grid>

      <Grid  item xs sm md lg xl >
        <LogInForm/>
      </Grid>

    </Grid>

  </Paper>

    
  )
}




